import produce from 'immer';

// TYPES
import { Types, AtualizarOrgao } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: AtualizarOrgao = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarOrgao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_ORGAO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_ORGAO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_ORGAO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_ORGAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
